angular.module("digitalLeasing.module").component("goodManagement", {
  templateUrl: "ng/components/digitalLeasing/goodManagement/goodManagement.view.html",
  bindings: {
    model: "=",
    validateCespiti: "&",
    invalidateCespiti: "&",
    validateAliquota: "&",
    invalidateAliquota: "&",
    snapshot: '<',
    viewName: '<',
    buttonModal: '&',
    portalRunned: '<',
    hideMasterFooter: '&'
  },
  controllerAs: "goodManagementCtrl",
  controller: GoodManagementController
});

function GoodManagementController(
  $financialApiService,
  $rootScope,
  $location,
  $transactionFactory,
  FinancialModel
) {
  var self = this;

  self.$onInit = function () {
    self.$rootScope = $rootScope;
    self.supportModel = {
      amountIsNotOk: false
    }

    callcheckIban();
    checkAllCespiti();
  };

  self.validateAmount = function (amount) {

    amount == self.model.leasingData.preventivo.importo ?
      self.supportModel.amountIsNotOk = false : self.supportModel.amountIsNotOk = true;

    self.validateGoodManagement();
  }

  self.validateGoodManagement = function () {
    //all'oninit self.checkCespiti è sempre undefined
    var check = typeof self.checkCespiti == "undefined" ? true : self.checkCespiti;

    if (check && !self.supportModel.amountIsNotOk && self.validateIndividualPerson && !self.loadingTrasformRest) {
      self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
        if (element.cespiteIsOk) {
          self.validateCespiti();
        } else {
          self.invalidateCespiti();
        }
      });
    } else {
      self.invalidateCespiti();
    }
  }

  self.cespitePagIsOk = function () {
    self.checkCespiti = true;
    self.validateGoodManagement();
  }

  self.cespitePagIsNotOk = function () {
    self.checkCespiti = false;
    self.validateGoodManagement();
  }

  self.aliquotaIsOk = function () {
    self.checkAliquotaComponent = true;
    checkAliquota();
  }

  self.aliquotaIsNotOk = function () {
    self.checkAliquotaComponent = false;
    checkAliquota();
  }

  var checkAliquota = function () {
    var check = self.checkAliquotaComponent;

    if (check) {
      self.validateAliquota();
    } else {
      self.invalidateAliquota();
    }

  }

  var checkAllCespiti = function () {
    self.model.leasingData.preventivo.prodotto.beneContratto.forEach(function (element) {
      if (element.ivaBene.id && element.resa.id &&
        element.codiceCDU && element.garanzia.id &&
        (element.fornitore.riUserG && (element.fornitore.riUserG.cf || element.fornitore.riUserG.ndg)) ||
        (element.fornitore.riUserF && element.fornitore.riUserF.cf)) {
        element.cespiteIsOk = true;
        self.validateCespiti();
      } else {
        element.cespiteIsOk = false;
        self.invalidateCespiti();
      }
    });
  }

  var callcheckIban = function () {
    if (self.model.financialCustomer.metadata.autorizzazione.iban) {
      $financialApiService
        .checkIban(self.model.financialCustomer.metadata.autorizzazione.iban)
        .then(function (ibanResponse) {
          console.log('product is: ', ibanResponse);
        })
        .catch(function (err) {
          console.log("Errore: ", err);
        })
    }
  }

  self.pageIndividualPersonIsOk = function () {
    self.validateIndividualPerson = true;
    self.validateGoodManagement();

  }

  self.pageIndividualPersonIsNotOk = function () {
    self.validateIndividualPerson = false;
    self.validateGoodManagement();
  }

  self.closeModal = function () {
    self.$rootScope.openModalIdentificazione = false;
  }

  self.goToRiepilogo = function () {
    self.loadingTrasformRest = true;
    self.validateGoodManagement();
    var FEOption = self.model.frontEndOptions;
    $financialApiService.transformModelForSummary(FinancialModel.build(self.model))
      .then(function (modelModify) {
        if (!self.snapshot) {
          Object.assign(modelModify, {
            frontEndOptions: FEOption
          })
          $transactionFactory.set(modelModify)
          $location.path('/riepilogo&Controllo');
          self.loadingTrasformRest = false;
          self.validateGoodManagement();
        } else {
          self.riepilogoModel = modelModify;
          self.loadingTrasformRest = false;
          self.visualRiepilogo = true;
          self.hideMasterFooter({
            value: true
          });
        }

      })
      .catch(function (error) {
        console.log(error);
        self.loadingTrasformRest = false;
        self.validateGoodManagement();
      })

  }

  self.returMonitorFunc = function () {
    self.visualRiepilogo = false;
    self.hideMasterFooter({
      value: false
    });
  }

  self.handleQuoteChange = function () {
    self.model.leasingData.contratto.note = self.model.leasingData.contratto.note &&
      self.model.leasingData.contratto.note.replace(/[\u0000-\u001f]/gi, '')
      .replace(/[\u0080-\u009f]/gi, '')
      .replace(/[\u0100-\uffff]/gi, '')
  }

  self.showHidedownloadInfoBancaFn = function (value) {
    self.showHidedownloadInfoBanca = value;
  }
}